import {Instance, SnapshotIn, types} from 'mobx-state-tree';
import {ResetModel} from 'core/models';

const DeveloperMode = types
  .compose(
    ResetModel,
    types.model('DeveloperMode', {
      isActive: false,
      isInspector: false
    })
  )
  .actions((self) => ({
    toggleActive(): void {
      if (self.isActive) {
        self.isInspector = false;
        self.isActive = false;
      } else {
        self.isActive = true;
      }
    },
    toggleFieldInspector(): void {
      self.isInspector = !self.isInspector;
    }
  }));

export type TDeveloperModeModel = Instance<typeof DeveloperMode>;
export type TDeveloperModeSnapshotIn = SnapshotIn<typeof DeveloperMode>;

export {DeveloperMode};
